import type { QuestionResponseSchema } from "@/hera-api/client/types.gen";

/** Merge de-registration question definitions from multiple sources (deduped by id). */
export function mergeDeregistrationQuestions(
  ...sources: Array<QuestionResponseSchema[] | undefined>
): QuestionResponseSchema[] {
  const byId = new Map<string, QuestionResponseSchema>();
  for (const source of sources) {
    for (const question of source ?? []) {
      if (question.question_type !== "deregistration") {
        continue;
      }
      if (!byId.has(question.id)) {
        byId.set(question.id, question);
      }
    }
  }
  return [...byId.values()].sort(
    (a, b) => (a.display_order ?? 0) - (b.display_order ?? 0),
  );
}
